/* unplugin-vue-components disabled */import script from "./HostHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./HostHeader.vue?vue&type=script&setup=true&lang=ts"

import "./HostHeader.vue?vue&type=style&index=0&id=0e9efec2&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e9efec2"]])

export default __exports__